import { FC, useEffect, useState } from "react";
import { RentalType } from "../../types";
import { BsChatText } from "react-icons/bs";
import Loading from "../loading/Loading";
import { ipfsGatewayImage } from "../../utils/ipfsGatewayImage";
import { calculateHoursBetweenDates } from "../../utils/hoursBetweenDates";
import { RxAvatar } from "react-icons/rx";
import { logo } from "../../assets/images";
import { useForm } from "react-hook-form";
import RentalChat from "../rentalChat/RentalChat";

interface Props {
  rental: RentalType;
}

const HostCars: FC<Props> = ({ rental }) => {
  const [images, setImages] = useState<string[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const [isOpen, setIsOpen] = useState(false);
  const [isChatOpen, setIsChatOpen] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();

  const openModal = () => {
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
  };
  const openChat = () => {
    setIsChatOpen(true);
    setIsOpen(!isOpen);
  };

  const closeChat = () => {
    setIsChatOpen(false);
  };

  const onSubmit = (data: any) => {
    console.log(data?.file[0]);

    // Clear the form
    reset();

    // Close the chat form
    closeChat();
  };

  useEffect(() => {
    setLoading(true);

    if (rental.car.carImages[0]) {
      // const images = splitStringByComma(vehicle?.carImages[0]?.imageUrl);
      const imgArr = rental.car.carImages?.filter(
        (image: any) => image.imageUrl
      );
      const imgMap = imgArr.map((image: any) => image.imageUrl);
      const imgArrs = new Set(imgMap);

      // console.log(images);
      setImages(Array.from(imgArrs));
    }
    setLoading(false);
  }, [rental.car.carImages]);

  if (loading) return <Loading loading={loading} />;

  return (
    <div className=" h-[274px] w-[320px] p-3 rounded-lg flex flex-col gap-3 bg-white">
      <div className="flex  w-full items-center justify-between rounded-lg border border-midGreen p-2">
        <div className="flex w-full gap-2 items-start flex-1">
          <p className=" bg-midGreen text-white text-sm p-2 capitalize rounded-full">
            {rental.lessee.firstName[0]}
            {rental.lessee.lastName[0]}
          </p>
          {/* <div className="flex flex-col"> */}
          <p className="text-sm font-bold text-darkText">
            {rental.lessee.firstName} {rental.lessee.lastName}
          </p>
          {/* <p className="text-xs font-medium text-midGreen">{rental.lessee.email}</p> */}
          {/* </div> */}
        </div>
        {/* <button
          type="button"
          className="flex gap-2 bg-white border-midGreen rounded-lg text-[#19B375] font-bold text-[12px] leading-[150%]"
          onClick={openModal}
        >
          <BsChatText className="text-[#19B375] text-[24px]" />
          Chat
        </button> */}
        <RentalChat
          title={"Lessor"}
          lessorId={rental.car.lessor.id}
          lesseeId={rental.lessee.id}
          rentalID={rental.id}
          className=" w-fit border-none"
        />
        {isOpen && (
          <div className="fixed top-0 left-0 w-full h-full flex items-center justify-center z-50 bg-black bg-opacity-50">
            <div className="bg-white p-8 rounded shadow-lg min-w-80">
              <h2 className="mb-4 text-lg font-semibold text-gray-700">
                Chat Options
              </h2>
              <div className="flex justify-between gap-10">
                <button
                  className="flex flex-col gap-2 items-center w-full font-Jakarta text-base font-medium   text-darkGreen text-nowrap"
                  onClick={() => {}}
                >
                  <RxAvatar className="h-6 w-6 object-cover" />
                  Chat with Lessee
                </button>
                <button
                  className="flex flex-col gap-2 items-center w-full font-Jakarta text-base font-medium  text-midGreen text-nowrap"
                  onClick={openChat}
                >
                  <img src={logo} alt="" className=" h-6 w-6 object-cover" />
                  Chat with Ecomoto
                </button>
              </div>
              <button
                className="mt-4 block w-full py-2 px-4 rounded bg-red-500 text-white"
                onClick={closeModal}
              >
                Close
              </button>
            </div>
          </div>
        )}
      </div>
      <div className="flex w-full gap-3 -start">
        <img
          src={ipfsGatewayImage(images[0])}
          alt=""
          className="h-[50px] w-[84px] object-cover"
        />
        <div className="flex flex-1 flex-col gap-3">
          <div className="flex flex-row justify-between ">
            <p className=" font-Jakarta font-semibold leading-[150%] text-[10px] text-lightGreyText uppercase">
              Booking details
            </p>
            <p
              className={` font-Inter text-[12px] font-normal text-center h-4 w-[58px] rounded-md ${
                rental.rentalStatus === "Active"
                  ? "text-[#11B981 bg-[#CFF1E6]"
                  : rental.rentalStatus === "Booked"
                  ? "text-[#F59E0B] bg-[#FFF7E5]"
                  : rental.rentalStatus === "Rejected"
                  ? "text-[#EB5757] bg-[#F9D2DA]"
                  : "text-[#3D475C] bg-[#F6F7F9]"
              }`}
            >
              {rental.rentalStatus}
            </p>
          </div>
          <div className="flex justify-between">
            <div className="flex gap-3  flex-col">
              <div className="flex flex-col gap-1 items-start justify-between">
                <p className="text-[10px] font-Jakarta font-normal text-midGreen">
                  Booking ID
                </p>
                <p className="text-[12px] leading-[150%] font-semibold text-[#596780] ">
                  #{rental.id.slice(0, 6)}...
                </p>
              </div>
              <div className="flex flex-col gap-1 items-start justify-between">
                <p className="text-[10px] font-Jakarta font-normal text-midGreen">
                  Pickup Time
                </p>
                <p className="text-[12px] leading-[150%] font-semibold text-[#596780] ">
                  {new Date(rental.rentalStartDatetime).getUTCHours()} :{" "}
                  {new Date(rental.rentalStartDatetime).getUTCMinutes()}
                </p>
              </div>{" "}
              <div className="flex flex-col gap-1 items-start justify-between">
                <p className="text-[10px] font-Jakarta font-normal text-midGreen">
                  Return Time
                </p>
                <p className="text-[12px] leading-[150%] font-semibold text-[#596780] ">
                  {new Date(rental.rentalEndDatetime).getUTCHours()} :{" "}
                  {new Date(rental.rentalEndDatetime).getUTCMinutes()}
                </p>
              </div>
            </div>
            <div className="flex gap-3  flex-col">
              <div className="flex flex-col gap-1 items-start justify-between">
                <p className="text-[10px] font-Jakarta font-normal text-midGreen">
                  Duration
                </p>
                <p className="text-[12px] leading-[150%] font-semibold text-[#596780] ">
                  {calculateHoursBetweenDates(
                    new Date(rental.rentalStartDatetime),
                    new Date(rental.rentalEndDatetime)
                  )}{" "}
                  hours
                </p>
              </div>
              <div className="flex flex-col gap-1 items-start justify-between">
                <p className="text-[10px] font-Jakarta font-normal text-midGreen">
                  Pickup Date
                </p>
                <p className="text-[12px] leading-[150%] font-semibold text-[#596780] ">
                  {new Date(rental.rentalStartDatetime).toDateString()}
                </p>
              </div>{" "}
              <div className="flex flex-col gap-1 items-start justify-between">
                <p className="text-[10px] font-Jakarta font-normal text-midGreen">
                  Return Date
                </p>
                <p className="text-[12px] leading-[150%] font-semibold text-[#596780] ">
                  {new Date(rental.rentalEndDatetime).toDateString()}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {isChatOpen && (
        <div className="fixed top-0 left-0 w-full h-full flex items-center justify-center z-50 bg-black bg-opacity-50">
          <div className="bg-white p-8 rounded shadow-lg min-w-80">
            <h2 className="mb-4 text-lg font-semibold text-gray-700">
              Send a Message to Ecomoto
            </h2>
            <form
              onSubmit={handleSubmit(onSubmit)}
              className="flex flex-col gap-3"
            >
              <label className="block mb-2">Subject</label>
              <div className="">
                <input
                  {...register("subject", { required: true })}
                  type="text"
                  className="block w-full mb-4 p-2 border border-gray-300 rounded"
                />

                {errors.subject && (
                  <p className=" text-red-500">This field is required</p>
                )}
              </div>

              <label className="block mb-2">Message</label>
              <div className="">
                <textarea
                  {...register("message", { required: true })}
                  className="block w-full mb-4 p-2 border border-gray-300 rounded"
                />

                {errors.message && (
                  <p className=" text-red-500">This field is required</p>
                )}
              </div>

              <label className="block mb-2">Attachment (optional)</label>
              <input
                {...register("file")}
                type="file"
                className="block w-full mb-4 p-2 border border-gray-300 rounded"
              />

              <button
                type="submit"
                className="block w-full py-2 px-4 rounded bg-midGreen text-white"
              >
                Send
              </button>
            </form>
            <button
              className="mt-4 block w-full py-2 px-4 rounded bg-red-500 text-white"
              onClick={closeChat}
            >
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default HostCars;
